import React, {Component} from 'react'
import {Button, Collapse, Modal, ModalBody, ModalHeader, ModalFooter} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {toast} from "react-toastify";
import {Mutation} from 'react-apollo'

import UserRoleRatesList from "./UserRoleRatesList";
import UserRoleRateInput from "./UserRoleRateInput";
import createUserRoleHourlyRate from '../../../queries/server/mutations/create_user_role_hourly_rate'
import userRoleRateTimesheetCheck from '../../../queries/server/mutations/user_role_rate_timesheet_check'
import updateUserRoleLocalMutation from '../../../queries/client_side/mutations/edit_user_role'

export default class UserRoleRates extends Component {

    constructor(props){
        super(props)
        this.newRecord = null
    }

    state = {
        showInput: false,
        showTimesheetAlert: false
    }

    toggle = () => {
        this.setState({showInput: !this.state.showInput})
    }

    toggleTimesheetAlert = () => {
        this.setState({showTimesheetAlert: !this.state.showTimesheetAlert})
    }

    render() {

        const {state} = this
        const {data, user_role} = this.props
        const {showInput} = state

        return (
            <div>
                <Button
                    size="sm"
                    color={state.showInput ? 'warning' : 'success'}
                    onClick={this.toggle}
                >
                    <FontAwesomeIcon color="#fff"
                                     icon={state.showInput ? 'minus' : 'plus'}/>{' '}
                    {state.showInput ? 'Cancel' : 'Add Hourly Rate'}
                </Button>

                <div className="mt-3">
                    <UserRoleRatesList
                        data={data}
                    />
                </div>

                <Mutation mutation={updateUserRoleLocalMutation}>
                    {(updateUserRoleLocalMutationFunc) => (
                        <Mutation mutation={createUserRoleHourlyRate}>
                            {(createUserRoleHourlyRateFunc, {loading}) => (
                                <Mutation mutation={userRoleRateTimesheetCheck}>
                                    {(userRoleRateTimesheetCheckFunc, checkState) => (
                                        <div>
                                            <UserRoleRateInput
                                                user_role_name={user_role.description}
                                                toggle={this.toggle}
                                                isOpen={showInput}
                                                loading={loading || checkState.loading}
                                                onSave={(newRecord) => {

                                                    this.newRecord = newRecord

                                                    userRoleRateTimesheetCheckFunc({
                                                        variables: {
                                                            user_role_id: user_role.user_role_id,
                                                            active_from: newRecord.active_from
                                                        }
                                                    })
                                                        .then(({data}) => {
                                                            if (data.checkTimesheetsAfterUserRoleRateChange > 0) {

                                                                this.toggleTimesheetAlert()

                                                            }
                                                            else {
                                                                createUserRoleHourlyRateFunc({
                                                                    variables: {
                                                                        data: {...newRecord},
                                                                        user_role_id: user_role.user_role_id,
                                                                        update_timesheets: false
                                                                    }
                                                                })
                                                                    .then(({data: {createUserRoleHourlyRate}}) => {
                                                                        updateUserRoleLocalMutationFunc({
                                                                            variables: {
                                                                                data: createUserRoleHourlyRate
                                                                            }
                                                                        })
                                                                        this.toggle()
                                                                        toast.success('Hourly Rates Created', {autoClose: 2000})
                                                                    })
                                                                    .catch(e => toast.error(e.message, {autoClose: false}))
                                                            }
                                                        })


                                                }}
                                            />

                                            <Modal isOpen={this.state.showTimesheetAlert}>
                                                <ModalHeader>Timesheets Update</ModalHeader>
                                                <ModalBody>
                                                    There are a number of timesheets, submitted by users who are
                                                    assigned this user role, which are after the specified
                                                    "Active From Date".
                                                    Would you like to update the timesheets with the new hourly
                                                    rate?
                                                </ModalBody>
                                                <ModalFooter>
                                                    <Button
                                                        size="sm"
                                                        color="secondary"
                                                        disabled={loading}
                                                        onClick={() => {

                                                            this.toggleTimesheetAlert()

                                                            createUserRoleHourlyRateFunc({
                                                                variables: {
                                                                    data: {...this.newRecord},
                                                                    user_role_id: user_role.user_role_id,
                                                                    update_timesheets: false
                                                                }
                                                            })
                                                                .then(({data: {createUserRoleHourlyRate}}) => {
                                                                    updateUserRoleLocalMutationFunc({
                                                                        variables: {
                                                                            data: createUserRoleHourlyRate
                                                                        }
                                                                    })
                                                                    this.toggle()
                                                                    toast.success('Hourly Rates Created', {autoClose: 2000})
                                                                })
                                                                .catch(e => toast.error(e.message, {autoClose: false}))
                                                        }}
                                                    >
                                                        <FontAwesomeIcon
                                                            color="#fff"
                                                            icon={loading ? 'spinner' : 'times'}
                                                            spin={loading}
                                                        />{' '}
                                                        {(loading) ? 'Saving...' : "Don't Update"}
                                                    </Button>
                                                    <Button
                                                        size="sm"
                                                        color="success"
                                                        type="submit"
                                                        disabled={loading}
                                                        onClick={() => {

                                                            this.toggleTimesheetAlert()

                                                            createUserRoleHourlyRateFunc({
                                                                variables: {
                                                                    data: {...this.newRecord},
                                                                    user_role_id: user_role.user_role_id,
                                                                    update_timesheets: true
                                                                }
                                                            })
                                                                .then(({data: {createUserRoleHourlyRate}}) => {
                                                                    updateUserRoleLocalMutationFunc({
                                                                        variables: {
                                                                            data: createUserRoleHourlyRate
                                                                        }
                                                                    })
                                                                    this.toggle()
                                                                    toast.success('Hourly Rates Created', {autoClose: 2000})
                                                                })
                                                                .catch(e => toast.error(e.message, {autoClose: false}))
                                                        }}
                                                    >
                                                        <FontAwesomeIcon
                                                            color="#fff"
                                                            con={loading ? 'spinner' : 'check'}
                                                            spin={loading}
                                                        />{' '}
                                                        {(loading) ? 'Saving...' : "Update Timesheets"}
                                                    </Button>
                                                </ModalFooter>
                                            </Modal>

                                        </div>
                                    )}

                                </Mutation>
                            )}
                        </Mutation>
                    )}
                </Mutation>
            </div>
        )

    }

}